module.exports = __webpack_public_path__ + "media/images/menu-icons/events-34e2e2d8c9d014b3d378a8ca642539c4.svg";